import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { personSchema } from '@/lib/seo';
import './index.css';

// JSON-LD injected at runtime rather than hardcoded in index.html, so the
// structured data is generated from the same src/data as everything else and
// cannot drift from the visible page.
const ld = document.createElement('script');
ld.type = 'application/ld+json';
ld.textContent = JSON.stringify(personSchema(window.location.origin + import.meta.env.BASE_URL));
document.head.appendChild(ld);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
